import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

const productContentUrl = "/api/v2/productcontent";

export interface ProductDataPointResultModel {
    result?: string;
    dimensions?: string;
}

export interface ProductDataPointParams extends ApiParameter {
    productNumber?: string;
}

export async function getProductContent(parameter: ProductDataPointParams) {
    const response = await get<string>(productContentUrl, {
        additionalQueryStringParameters: {
            erpNumber: parameter.productNumber,
        },
    });
    return response;
}